<template>
<div style="margin-top: 20px;">
   <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="fullPage"></loading>
  <div class="container maincontent">
    <!-- <div class="container-fluid "> -->
      <div class="card">
          <div class="">

<div class="card-body">
<div class="tab-content">
<div class="active tab-pane" id="activity">
  <div class="row postdata">
    <div  style="margin-top:20px">
    <div class="nav">
    <!-- <ul class="nav nav-tabs navTab">
              <li class="active" v-on:click="navigation('Post')"><a href="#tab_1" data-toggle="tab">Post</a></li>
              <li v-on:click="navigation('To-be-Scheduled')"><a href="#tab_2" data-toggle="tab">Interest</a></li>
              <li v-on:click="navigation('Scheduled')"><a href="#tab_3" data-toggle="tab">Availability</a></li>
              <li v-on:click="navigation('Schedule')"><a href="#tab_3" data-toggle="tab">Schedule</a></li>
              <li v-on:click="navigation('Feedback')"><a href="#tab_4" data-toggle="tab">Feedback</a></li>
            </ul> -->
    <div class="box-header">
                    <h3 class="box-title pageTitle">Post</h3>
                  </div>
                  <hr class="myline">
                  <div class="box-header with-border filterdata">
                    <input v-model="postsearch" @keyup="postList()" type="text" class="form-control pull-left search-text" placeholder="Search" style="width:50%;height:30%">
                    <div style="width:50%;" class="pull-right filterby">
                      <div class="form-group">
                        <div class="form-select pull-right range" style="width: 50%;;height:30%">
                          <select @change="postList()" v-model="postsort" class="form-control input-sm  ">
                            <option value="7" class="doption">Last 7 days</option>
                            <option value="30" class="doption">Last 30 days</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                      <label class="pull-right ml-1">Sort by</label>
                    </div>
                  </div>
  <div class="text-center">
<div class="box-body">
                    <ul style="list-style:none" v-for="(post,index) in mypostList" :key="index">
                      <li class="myPostArea" >
                        <div  class="postArea" >
  <div type="button" data-toggle="modal" data-target="#mypost" v-on:click="postDetails(post._id,index)" class=" myorgData">
  <div class="Orgimage">
    <img class="round" v-if="post.profile_picture !='' && post.profile_picture !=null" :src="`${post.profile_picture}`" alt="">
    <img class="round" v-if="post.profile_picture =='' || post.profile_picture ==null" src="../../../assets/img/default.png" alt=""></div>
 <div class="intDetails">
  <div class="uniqueId">
  <div class="org"><strong class="myorgName">{{post.organization}}</strong>
  </div>
</div>
  </div>
  </div>
  <div class="position">
    <div class="val ">
    <label class="labelcss" for="">Position: </label>
    <div class="" style="font-size:14px">
      <p class="mytitle">{{post.job_tittle}}</p>
    </div></div>
    <div class="val">
<label class="labelcss" for="">Primary Skills:</label>
<p class="validity">{{post.primaryskillnames}}</p>
</div></div>
  <div class="interestbtn">
<div class="myBookmark"><i :style="post.bookmarkstatus=='Yes' ? 'color:red':'color:#5bad2b'"  v-on:click ="bookmarkPost(post._id,index)" class="fa fa-bookmark-o bookmarkicon"  aria-hidden="true"></i>
<span> {{post.created_at | timeago}}</span>
</div>
    <button type="button" class="btn btn-success intbtn" @click="interest(post._id,post.user_id)">  Interest</button>
  </div>
  </div>
  <hr style="margin-top:2px; margin-bottom:6px" />
  <div class="vali">
  <label  class="labelcss" for="">Validity:</label>
  <p class="valdate">{{post.post_validity | formatDate }} </p>
  </div>
  </li>
  </ul>
</div>
</div>
</div>
</div>
<div class="tab-pane" id="timeline">
<div class="skillset">
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<!-- Modal for #mypost -->
<div class="modal fade" id="mypost" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title closebtnmodel " id="exampleModalLabel"><strong style="font-size:18px">Hi {{firstName.first_name}}</strong> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button></h5>
      </div>
      <div class="modal-body modalbody">
        <div class="myPostArea">
        <div class="postAreapopUp">
        <div class="myorgData1">
  <div class="Orgimagepopup">
    <img class=" profile-user-img img-fluid img-circle myprofile" v-if="postDetail.profile_picture !='' && postDetail.profile_picture !=null" :src="`${postDetail.profile_picture}`" alt="User profile picture">
<img v-if="postDetail.profile_picture =='' || postDetail.profile_picture ==null" src="../../../assets/img/default.png" class="profile-user-img img-responsive img-circle">
  </div>
 <div class="intDetails6">
  <div class="uniqueId">
  <div><strong class="myorgName">{{postDetail.organization}}</strong>
  </div>
</div>
  </div>
  </div>
  <div class="val ">
    <label for="" class="labelcss">Position: </label>
    <div style="font-size:14px">
      <p class="mytitle">{{postDetail.job_tittle}}</p>
    </div></div>
  <div class="interestbtn">
    <div class="myBookmarkstate" :style="postDetail.bookmarkstatus=='Yes' ? 'color:red':'color:#5bad2b'" v-on:click="bookmarkPost(postDetail._id)">
          <i  class="fa fa-bookmark-o bookmarkicon" aria-hidden="true" > </i>
          <span v-if="postDetail.bookmarkstatus == 'Yes'" >Bookmarked</span>
                    <span v-else >Bookmark</span>

          </div>
          <!-- </span> -->

    <!-- <div class="myBookmark">
    <label class="labelcss" for="">Validity:
    </label>
    <p class="valdate">{{postDetail.post_validity | formatDate}} </p>
    </div> -->
  </div>
  </div>
  <hr style="margin-top:2px; margin-bottom:6px" />
                            <div class="myBookmark">
                  <label class="labelcss" for="">Validity: </label>
                  <p class="valdate">{{ postDetail.post_validity | formatDate }}</p>
                </div>
        </div>
    <div class="postDetails">
    <h4 class="myHeading">Post Details</h4>
<hr>
<div class=" postDatas">
  <div class="Intdetails"><label for="" class="pd">Primary Skills :</label> <span>{{postDetail.primaryskillnames}}</span></div>
    <div class="Intdetails" ><label for="" class="pd">Secondary Skills :</label> <p>{{postDetail.secondaryskillnames}}</p></div>
    <div class="Intdetails"><label for="" class="pd">Experience :</label> <p>{{postDetail.year_of_experience}} Year {{postDetail.month_of_experience}} month</p> </div>
    <div class="Intdetails"><label for="" class="pd">Interview type :</label> <p>{{postDetail.job_interview_type}}</p> </div>
</div>
  </div>
  <hr>
<div class="JobDescription">
  <h4 class="myHeading">Job Description</h4>
  <hr>
  <p>
    <span class="labelcss">{{postDetail.org_description}}</span>
  </p>
</div>
<hr>
<div class="comments">
  <h4 class="myHeading">Comments</h4>
<hr>
<div><p class="labelcss">{{postDetail.job_comments}}</p></div>
      </div>
<!-- </div> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success"  @click="interest(postDetail._id,postDetail.user_id)">
 Interest</button>
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import $ from 'jquery'

export default {
  data () {
    return {
      fullPage: true,
      isLoading: false,
      postsearch: '',
      postsort: 7,
      // user_id: 421,
      user_id: localStorage.getItem('user_id'),
      // user_id: this.$route.params.id,
      post_id: [],
      org_id: '',
      isBookmark: false,
      bookmarkValue: '',
      postDetail: [],
      mypostList: [],
      myCurrentDate: '',
      myPastDate: '',
      startdate: '',
      enddate: '',
      myInterest: [],
      clicked: false,
      firstName: [],
      postIndex: ''
    }
  },
  components: {
    Loading
  },
  created () {
    localStorage.getItem('token')
    // console.log(localStorage.getItem('token'))
    localStorage.getItem('user_id')
    localStorage.getItem('user__details')
    console.log(localStorage.getItem('user__details'))
    // this.postDetails()
    this.postList()
    this.firstName = JSON.parse(localStorage.getItem('user__details'))

    // this.interest()
  },
  methods: {
    interest (_id, orgId) {
      $('#mypost').modal('hide')
      this.isLoading = true
      const data = {
        user_id: localStorage.getItem('user_id'),
        post_id: _id,
        org_id: orgId
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/dashboard/add_interviewer_interest/ios', { formData: data }, config).then(response => {
        this.myInterest = response.data.interestInfo
        this.isLoading = false
        this.$awn.success('Thanks for showing interest,the post is now moved to interest section')
        this.postList()
        console.log(this.myInterest)
      }).catch(error => {
        console.log(error)
      })
    },
    bookmarkPost (_id, index = null) {
      const data = {
        post_id: _id,
        user_id: localStorage.getItem('user_id')
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      if (index != null) {
        this.mypostList[index].bookmarkstatus = this.mypostList[index].bookmarkstatus === 'No' ? 'Yes' : 'No'
      } else {
        // this.postIndex
        console.log('hi', this.mypostList[this.postIndex])
        this.mypostList[this.postIndex].bookmarkstatus = this.postDetail.bookmarkstatus === 'No' ? 'Yes' : 'No'

        this.postDetail.bookmarkstatus = this.postDetail.bookmarkstatus === 'No' ? 'Yes' : 'No'
      }
      axios.post(BaseURL + '/dashboard/add_bookmark_post/ios', { formData: data }, config).then(response => {
        console.log(response)
      }).catch(error => {
        console.log(error)
      })
    },
    postList () {
      // if (this.postsort === 0) {
      //   this.postsort = 0
      //   this.myCurrentDate = ''
      //   this.myPastDate = ''
      // } else {
      this.myCurrentDate = moment().format('YYYY-MM-DD')
      console.log(this.myCurrentDate)
      this.myPastDate = moment().subtract(this.postsort, 'days').format('YYYY-MM-DD')
      console.log(this.myPastDate)
      // }
      // this.myCurrentDate = moment().format('YYYY-MM-DD')
      // console.log(this.myCurrentDate)
      // this.myPastDate = moment().subtract(this.postsort, 'days').format('YYYY-MM-DD')
      // console.log(this.myPastDate)
      const data = {
        user_id: localStorage.getItem('user_id'),
        sort: this.postsort,
        startdate: this.myPastDate,
        enddate: this.myCurrentDate,
        search: this.postsearch,
        bookmark: this.bookmarkValue
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.post(BaseURL + '/dashboard/get_post_list/ios', { formData: data }, config).then(response => {
        this.mypostList = response.data.interviewerList
        this.post_id = response.data.interviewerList
        for (let i = 0; i < this.mypostList.length; i++) {
          this.clicked.push(false)
          // if (this.mypostList[i].value === this.clicked[i]._id) {
          //   this.clicked = true
          // } else {
          //   this.clicked = false
          // }
        }
        console.log(this.post_id)
        console.log(this.mypostList)
      }).catch(error => {
        console.log(error)
      })
    },
    postDetails (_id, index) {
      this.postIndex = index
      this.post_id = _id
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/dashboard/get_post_details/ios/' + this.post_id + '/' + this.user_id, config).then(response => {
        this.postDetail = response.data.interviewerList[0]
        console.log(this.postDetail)
      }).catch(error => {
        console.log(error)
      })
    }

  },
  mounted: function () {
    var endDate = moment()
      .subtract(this.postsort, 'days')
      .format('ddd, YYYY MMM DD')
    var startDate = moment()
      .subtract(1, 'days')
      .format('ddd, YYYY MMM DD')
    this.startdate = moment(endDate)
    this.enddate = moment(startDate)
  }
}
</script>

<style lang="scss" scoped>
.myPostArea {
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.postArea{
   width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding:6px;
}
.postAreapopUp{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 5px;
  align-items: baseline;

}
.maincontent{
  background-color: white;
  padding: 10px;
  min-height: 450px;
}
.tabHeader{
  background-color: #f5f5f5;
}
.tabHeader .icon {
display: none;
}
.tabBtn>li>a {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 14px;
}
.tabBtn>li.active>a, .tabBtn>li.active>a:focus, .tabBtn>li.active>a:hover {
    color: #fff;
    background-color: #5bad2b;
        border-top-color: unset;
}
.tabBtn>li>a:hover{
  color:black;
  background-color:white

}
.profile-user-img{
  margin: 0px auto;
    width: 130px;
    padding: 1px;
    border: 4px solid #d2d6de;
}
.img-circle {
    border-radius: 50%;
}
.myprofile {
    width:  120px;
    height: 120px;
}
.round {
  width: 100px;
  height: 100px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 4px;
}
.uniqueId{
  display: flex;
  text-align: start;
}
.position{
  display: flex;
  text-align: start;
  flex-direction: column;
}
.myorgData{
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.myorgData:hover{
  cursor: pointer;
  // background-color: white;
}
.myorgData1{
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.filterdata{
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 8px  0px;
}
// .filterby{
//   align-items: center;
// }
.navTab{
  display: flex;
  justify-content: center;
}
.myBookmark{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 5px;
  align-content: center;
  align-items: baseline;
  padding: 0% 5px;
}
input:checked {
  background-color: #5bad2b;
}
.bookmarkiconBgClr{
  background-color: #5bad2b;
}
.interestbtn{
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  row-gap: 2px;
}
.closebtnmodel{
   display: flex;
   flex-direction: row;
    justify-content: space-between;
    padding: 10px;
 }
 .val{
   display: flex;
   flex-direction: row;
   justify-content: start;
   align-content: center;
   align-items: baseline;
   column-gap: 3px;
 }
 .vali{
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-content: center;
  align-items: baseline;
  column-gap: 5px;
  padding-right: 5px;
 }
 .postDatas{
    display: grid;
   grid-template-columns: 50% 50% ;
   gap: 0px 12px;
 }
 .Intdetails{
  display: flex;
  flex-direction: row;
  column-gap: 10px;
 }
 .intDetails6{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
 }
 .jobDescription{
    width: 100%;
 }
 .myline{
  margin-top: 0;
  margin-bottom: 0;
 }
 .pageTitle{
  font-size: 24px;
  font-weight: 400;
 }
 .green{
  color: #5bad2b;
 }
 .red{
  color: #ff0000;
 }
 .myBookmarkstate{
  display: flex;
  flex-direction: row;
  column-gap: 4px;
  align-content: center;
  align-items: center;
  padding: 1px;
 }
 .myorgName{
  font-size: 16px;
  font-weight: 600;
 }
 .ml-1{
  margin-top: 6px;
 }
 .myPostArea{
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: #f5f5f5;
}
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
   .round{
    width: 80px;
    height: 80px;
   }
   .myorgName{
    font-size: 12px;
    font-weight: 600;
   }
   .labelcss{
    font-size: 12px;
   }
.mytitle{
  font-size: 12px;
}
.validity{
  display: flex;
  flex-direction: row;
  font-size: 12px;
}
.valdate{
font-size: 10px;
}
.interestbtn{
  padding: 0%;
}
.val{
  padding: 0px;
}
.myorgData{
  display: flex;
  flex-direction: row;
}
.myBookmark{
  justify-content: flex-end;
  font-size: 10px;
  padding: 0% 5px;
}
.myBookmarkstate{
  font-size: 10px;
}
.intbtn{
  font-size: 10px;
}
.org{
  text-align: center;
}
.position{
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.postArea{
  padding:0px 5px;
}
.range{
  font-size: 5px;
}
.Intdetails{
  font-size: 12px;
}
.myprofile{
  width: 80px;
  height: 80px;
}
.myorgData1{
  display: flex;
  flex-direction: row;
  row-gap: 5px;
}
.pd{
  font-size: 11px;
}
.doption{
  font-size: 12px;
}
.myHeading,.pageTitle{
  font-size: 18px;
}
.modalbody{
  padding: 6px;
}
   }
</style>
